<template>
  <div class="chat__wrap chat__form">
    <div class="chat__form_wrap">
      <div class="title">Добавить комментарий</div>
      <div class="divider"></div>

      <div class="text-field text-field_dark-blue">
        <div class="text-field__slot">
          <textarea
            rows="5"
            @keyup.alt.enter="sendMessage"
            @keyup.ctrl.enter="sendMessage"
            placeholder="Введите ваш комментарий"
            v-model="text"
          ></textarea>
        </div>
      </div>

      <div class="chat__form_actions">
        <form-file
          :loading="processing && hasAttachedFiles"
          v-model="attachment"
          dropzone=".chat__form"
          @drop="onDropedFile"
          accept="image/jpg,image/jpeg,image/png"
          label="Прикрепить скриншот"
        />

        <div class="spacer"></div>

        <app-btn
          round
          color="orange-grad"
          @click="sendMessage"
          :disabled="processing"
          >Отправить</app-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import matchService from "@/services/match";
import showAlert from "@/services/common/showAlert";
import ioService from "@/services/io";

import FormFile from "@/components/ui/form/FormFile";

export default {
  components: { FormFile },
  props: {
    room: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      processing: false,

      text: "",
      attachment: null
    };
  },

  computed: {
    hasAttachedFiles() {
      return this.attachment && this.attachment.length > 0;
    },

    chatMessage() {
      return {
        room: `match${this.room}`,
        body: this.text || null
      };
    }
  },

  methods: {
    fileUploader(file, opts = {}) {
      const data = new FormData();
      data.append("image_file", file);

      return matchService.uploadFile(this.room, data, opts);
    },

    submitAttachment({ success, message, attachment }) {
      if (!success) throw message;

      return ioService.sendMsg({
        room: `match${this.room}`,
        body: `Прикреплен файл #${attachment.id}`,
        attachment: attachment.id
      });
    },

    async onDropedFile(file, opts, done) {
      try {
        const attach = await this.fileUploader(file, opts);
        await this.submitAttachment(attach);
      } catch (e) {
        showAlert(e);
      }

      if (typeof done == "function") done();
    },

    async sendMessage() {
      if (this.processing) return;
      this.processing = true;

      const msg = this.chatMessage;

      if (msg.body && msg.body.length) {
        await ioService.sendMsg(msg);

        this.$nextTick(() => {
          this.text = null;
        });
      }

      if (this.hasAttachedFiles) {
        try {
          const list = await Promise.all(
            this.attachment.map(file => this.fileUploader(file))
          );

          list.forEach(this.submitAttachment);
        } catch (e) {
          showAlert(e);
        }

        this.$nextTick(() => {
          this.attachment = null;
        });
      }

      this.$nextTick(() => {
        this.processing = false;
      });
    }
  }
};
</script>
